import { render, staticRenderFns } from "./Novelties.vue?vue&type=template&id=ed9db2e0&scoped=true"
import script from "./Novelties.vue?vue&type=script&lang=js"
export * from "./Novelties.vue?vue&type=script&lang=js"
import style0 from "./Novelties.vue?vue&type=style&index=0&id=ed9db2e0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9db2e0",
  null
  
)

export default component.exports